import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectChatRequestStatus, selectIsChatsEnabled } from 'shared/selectors/offerChat';

import { NewbuildingPushToCallStatusContainer } from '../NewbuildingPushToCallStatusContainer';

export const NewbuildingOnlineStatusContainer = () => {
  const isChatsEnabled = useSelector(selectIsChatsEnabled);
  const chatRequestStatus = useSelector(selectChatRequestStatus);

  if (isChatsEnabled || chatRequestStatus !== 'finished') {
    return null;
  }

  return <NewbuildingPushToCallStatusContainer />;
};
